import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { BUSINESS_MANAGER_URL } from 'utils/config';
import { fetchActorToken } from 'api/admin/users/users';
import { ApiError } from 'types/api';

interface UseImpersonateUserPayload {
  successCallback?: () => void;
}

interface FetchActorTokenResponse {
  id: string;
  status: string;
  userId: string;
  actor: { sub: string };
  token: string;
  url: string;
  createdAt: number;
  updatedAt: number;
}

export const useImpersonateUser = (params?: UseImpersonateUserPayload) => {
  return useMutation<unknown, ApiError, { userId: number }>({
    mutationFn: async ({ userId }) => {
      const { data } = (await fetchActorToken(userId)) as AxiosResponse<FetchActorTokenResponse>;
      window.open(
        `${BUSINESS_MANAGER_URL}/impersonate?ticket=${data.token}`,
        '_blank',
        'noopener,noreferrer',
      );
    },
    onSuccess: () => {
      params?.successCallback?.();
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? 'An error occurred while impersonating user.', {
        duration: 4000,
      });
    },
  });
};
